/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { PerpTokenMock } from "./PerpTokenMock";

export class PerpTokenMockFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<PerpTokenMock> {
    return super.deploy(overrides || {}) as Promise<PerpTokenMock>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): PerpTokenMock {
    return super.attach(address) as PerpTokenMock;
  }
  connect(signer: Signer): PerpTokenMockFactory {
    return super.connect(signer) as PerpTokenMockFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PerpTokenMock {
    return new Contract(address, _abi, signerOrProvider) as PerpTokenMock;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_totalSupply",
        type: "uint256",
      },
    ],
    name: "setTotalSupply",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b5060c38061001f6000396000f3fe6080604052348015600f57600080fd5b506004361060325760003560e01c806318160ddd146037578063f7ea7a3d146051575b600080fd5b603d6062565b604051604891906084565b60405180910390f35b6060605c366004606d565b6068565b005b60005481565b600055565b600060208284031215607d578081fd5b5035919050565b9081526020019056fea2646970667358221220f0bf73f4823b7d4240a18d1e8f826c9f325802b22a49552d4d3915f32f24a2b464736f6c63430006090033";
